document.addEventListener("DOMContentLoaded", function () {
  /* window.addEventListener('scroll', resizeAnnouncementBarWrapper); */
  window.addEventListener("resize", resizeAnnouncementBarWrapper);

  function resizeAnnouncementBarWrapper(e) {
    const announcementBarWrapper = document.querySelector(
      ".essential_annoucement_bar_wrapper"
    );
    if (announcementBarWrapper == null) return;
    const siteHeader = document.querySelector(".site-header");
    siteHeader.style.top = announcementBarWrapper.clientHeight + "px";

    window.removeEventListener("scroll", resizeAnnouncementBarWrapper);
  }

  resizeMegaMenuOnSubcatsHoverState();
  setProductGridPreviewVideos();
});

function resizeMegaMenuOnSubcatsHoverState() {
  document
    .querySelectorAll(".navmenu-meganav--desktop ul.navmenu li:has(ul)")
    .forEach(function (li) {
      li.addEventListener("mouseenter", function (e) {
        const ul = li.querySelector("ul");
        if (ul.querySelector("li") == null) return;

        // get height of subcategories ul wrapper
        const ulHeight = ul.getBoundingClientRect().height + 100;
        setMegaMenuMinHeight(ulHeight, e.target);
      });
      li.addEventListener("mouseleave", function (e) {
        setMegaMenuMinHeight(0, e.target);
      });
    });
}

function setMegaMenuMinHeight(height, target) {
  if (height == 0) {
    target.closest(".navmenu-meganav--desktop").style.height = null;
    target.closest(
      ".navmenu-meganav--desktop .navmenu-meganav-wrapper"
    ).style.minHeight = null;
    return;
  }

  target.closest(".navmenu-meganav--desktop").style.height = height + "px";
  target.closest(
    ".navmenu-meganav--desktop .navmenu-meganav-wrapper"
  ).style.minHeight = height + "px";
}

function setProductGridPreviewVideos() {
  // Observe video wrap elements
  const elements = document.querySelectorAll(".productitem-video-preview");

  const onIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        initVideo(entry.target);
        observer.unobserve(entry.target);
      }
    });
  };

  const observerOptions = {
    root: null, // Use the viewport as the container
    rootMargin: "0px",
    threshold: 1,
  };

  const observer = new IntersectionObserver(onIntersection, observerOptions);
  elements.forEach((element) => observer.observe(element));

  function initVideo(videoWrap) {
    const videoUrl = videoWrap.dataset.videoUrl;
    const videoPreview = videoWrap.dataset.videoPreview;

    videoWrap.innerHTML = `<video 
		playsinline="playsinline" 
		autoplay="autoplay" 
		loop="loop" 
		muted="muted" 
		preload="metadata" 
		aria-label="Product preview" 
		poster="${videoPreview}">
			<source src="${videoUrl}" type="video/mp4">
			<img src="${videoPreview}">
	</video>`;
  }
}
